import { render, staticRenderFns } from "./HealthInfoCat.vue?vue&type=template&id=72acfe72&"
import script from "./HealthInfoCat.vue?vue&type=script&lang=js&"
export * from "./HealthInfoCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports